import { WritableSignal } from '@angular/core';
import { SelectListOption } from '@bmw-ds/components';
import * as v from 'valibot';

import { CountryConfigurationFeature } from '../../../../auth/user/user';
import { newSchema } from '../../../utils/valibot/schema';

export interface FeatureFlagViewModel {
  [countryCode: string]: FeatureFlagElementViewModel[];
}

export interface FeatureFlagElementViewModel {
  group: FeatureFlagGroupDetails;
  feature: CountryConfigurationFeature;
  text: { label: string; description: string };
  options: SelectListOption[];
  unchangedModel: string;
  model: WritableSignal<string>;
}

export interface FeatureFlagUpdate {
  feature: CountryConfigurationFeature;
  value: boolean | null;
}

export const DetailedCountryConfigurationFeatureSchema = newSchema(
  'DetailedCountryConfigurationFeatureSchema',
  v.object({
    feature: v.enum(CountryConfigurationFeature),
    resolvedValue: v.boolean(),
    storedValue: v.nullish(v.boolean()), // => undefined, null or boolean
    defaultValue: v.boolean(),
  }),
);

/** The record key is the country code. */
export const DetailedCountryConfigurationSchema = newSchema(
  'DetailedCountryConfigurationSchema',
  v.record(v.string(), v.array(DetailedCountryConfigurationFeatureSchema)),
);

export type DetailedCountryConfigurationFeature = v.InferOutput<typeof DetailedCountryConfigurationFeatureSchema>;
export type DetailedCountryConfiguration = v.InferOutput<typeof DetailedCountryConfigurationSchema>;

export interface FeatureFlagGroupDetails {
  id: FeatureFlagGroup;
  displayText: string;
  description?: string;
}

export enum FeatureFlagGroup {
  C2V = 'C2V',
  PERSONAL_DATA_ID = 'PERSONAL_DATA_ID',
  PERSONAL_DATA_NAME = 'PERSONAL_DATA_NAME',
  PERSONAL_DATA_OTHER = 'PERSONAL_DATA_OTHER',
  PROFILE_PAGE_FEATURES = 'PROFILE_PAGE_FEATURES',
  RETAIL = 'RETAIL',
  SEARCH_FIELD = 'SEARCH_FIELD',
  OTHER = 'OTHER', // (Implicit) default if no other group is assigned
}

/** Order which is used when rendering the component */
export const FEATURE_FLAG_GROUP_ORDER = [
  FeatureFlagGroup.PERSONAL_DATA_NAME,
  FeatureFlagGroup.PERSONAL_DATA_ID,
  FeatureFlagGroup.PERSONAL_DATA_OTHER,
  FeatureFlagGroup.SEARCH_FIELD,
  FeatureFlagGroup.PROFILE_PAGE_FEATURES,
  FeatureFlagGroup.RETAIL,
  FeatureFlagGroup.C2V,
  FeatureFlagGroup.OTHER,
];
